import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07b58748"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "editions-label" }, "Editions", -1))
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "preset-amounts" }
const _hoisted_5 = ["onClick"]

import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseInputForPledge',
  setup(__props) {

const store = useClaimStore();
const presetAmounts = [5, 25, 100];

// Set initial default value
store.setTokensToPurchase(5);

const allowOnlyNumbers = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value.replace(/[^0-9]/g, '');
  store.setTokensToPurchase(Number(value) || 1);
};

const setPresetAmount = (amount: number) => {
  store.setTokensToPurchase(amount);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      class: "number-input",
      inputmode: "numeric",
      onInput: allowOnlyNumbers,
      value: _unref(store).tokensToPurchase,
      "data-testid": "tokens-number-input"
    }, null, 40, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presetAmounts, (amount) => {
        return _createElementVNode("button", {
          key: amount,
          class: _normalizeClass(["preset-button", { active: _unref(store).tokensToPurchase === amount }]),
          onClick: ($event: any) => (setPresetAmount(amount))
        }, _toDisplayString(amount), 11, _hoisted_5)
      }), 64))
    ])
  ]))
}
}

})